import script from "./ForumForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumForm.vue?vue&type=script&setup=true&lang=js"

import "./ForumForm.vue?vue&type=style&index=0&id=71f50d96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71f50d96"]])

export default __exports__